export enum PaymentGateway {
  PAYMOB = 'paymob',
  GEIDEA = 'geidea'
}
